import { useEffect, useMemo, useState } from "react";

function storageKey(orgId, seasonId) {
  return `matrix-league:positions:${String(orgId || "unknown")}:${String(seasonId || "season")}`;
}

function readSnapshot(key) {
  try {
    const value = JSON.parse(window.localStorage.getItem(key) || "null");
    return value && typeof value === "object" ? value : { positions: {}, updatedAt: null };
  } catch {
    return { positions: {}, updatedAt: null };
  }
}

export default function useStandingsMovement(orgId, seasonId, standings = []) {
  const key = useMemo(() => storageKey(orgId, seasonId), [orgId, seasonId]);
  const [previous, setPrevious] = useState(() => ({ positions: {}, updatedAt: null }));
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setPrevious(readSnapshot(key));
  }, [key]);

  const movement = useMemo(() => {
    const result = {};
    standings.forEach((club) => {
      const oldPosition = Number(previous.positions?.[club.id] || club.position || 0);
      const currentPosition = Number(club.position || 0);
      result[club.id] = oldPosition && currentPosition ? oldPosition - currentPosition : 0;
    });
    return result;
  }, [standings, previous]);

  useEffect(() => {
    if (typeof window === "undefined" || !standings.length) return;
    const timer = window.setTimeout(() => {
      const updatedAt = new Date().toISOString();
      const positions = Object.fromEntries(standings.map((club) => [club.id, Number(club.position || 0)]));
      window.localStorage.setItem(key, JSON.stringify({ positions, updatedAt }));
      setLastUpdated(updatedAt);
    }, 650);
    return () => window.clearTimeout(timer);
  }, [key, standings]);

  return { movement, lastUpdated: lastUpdated || previous.updatedAt };
}
